import React from 'react';

export type ITextContent = {
  label?: string | JSX.Element;
  tailwindCss?: string;
};

export const TextContent = (props: ITextContent) => {
  const { label, tailwindCss } = props;

  return (
    <div className={tailwindCss + ' text-gray-600'}>
      <div>{label}</div>
    </div>
  );
};
